/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Copy: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M22 7H19V18C19 18.552 18.552 19 18 19H7V22C7 22.552 7.448 23 8 23H22C22.552 23 23 22.552 23 22V8C23 7.448 22.552 7 22 7Z' fill='currentColor' />
    <path d='M16 17H2C1.447 17 1 16.553 1 16V2C1 1.448 1.447 1 2 1H16C16.553 1 17 1.448 17 2V16C17 16.553 16.553 17 16 17Z' fill='currentColor' />
  </React.Fragment>
)
